import axios from 'axios'
import { Toast } from 'vant'
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : '',
  timeout: 60000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.url.includes('wxLogin')) {
      config.url = '' + config.url
    } else {
      console.log('yuuuu', config.url)
      // config.url = process.env.NODE_ENV === 'development' ? '/nbhparking' + config.url : '/nbhparking/' + config.url
      // config.url = '/wx' + config.url
    }

    if (['delete', 'get'].includes(config.method)) {
      config.params = {
        // communityId: '148',
        // community: '',
      }
    } else if (['post', 'put'].includes(config.method)) {
      if (!config.data) {
        config.data = {}
      }
    }
    let token = process.env.NODE_ENV === 'development' ? '' : window.localStorage.getItem('user_token') || ''
    config.headers['authorization'] = 'Bearer ' + token
    config.headers['Token'] = window.localStorage.getItem('user_token')

    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (response.headers['content-type'] !== 'application/json') {
      // 一般是文件下载
      return response
    }
    if (res.code !== 0 && res.code !== '0' && res.code !== 200) {
      return Promise.reject(res.msg || res.message || 'Error')
    } else {
      return res.data
    }
  },
  (error) => {
    console.log(error.message)
    return Promise.reject(error)
  }
)
export default service
